<template lang="pug"
src='./mechanical-systems.pug'>

</template>

<script>
import saveBtn from '@/common/components/saveBtn.vue'
import easyBtn from 'Common/components/easy-btn.vue'
import imgIcon from '@/common/img/baseline-clear-24px.svg'
import _ from 'lodash'
export default {
	name: 'mechanical-systems',
	props: ['project', 'control', 'readonly', 'findControlTextByKey'],
	components: { saveBtn, easyBtn },
	data () {
		return {
			imgIconDel: imgIcon,
			waterHeaterOpts: [],
			heatSysStore: [],
			waterHeaterOptsStore: [],
			coolSysStore: [],
			projConst: []
		}
	},
	beforeMount () {
		this.projConst = process.env.PROJ_CONST
		this.waterHeaterOpts = _.values(this.projConst.waterHeater.type)
	},
	created: function () {
		// console.log('electricHome', this.project.mechSystems.HVACSys[0].allElectric)
		this.electricHome(this.project.mechSystems.HVACSys[0].allElectric)
	},
	methods: {
		electricHomeChange (isElectric) {
			this.electricHome(isElectric)
		},
		coolSysSelectChange (value) {
			// console.log(' coolSysSelectChange ', value)
		},
		electricHome (isElectric) {
			if (isElectric) {
				this.heatSysStore = this.control.heatSys
				this.waterHeaterOptsStore = this.waterHeaterOpts
				this.coolSysStore = this.control.coolSys
				this.control.coolSys = _.filter(this.control.coolSys, (hetElem) => {
					return (hetElem.text.toLowerCase().indexOf('heatpump') !== -1)
				})
				this.control.heatSys = _.filter(this.control.heatSys, (hetElem) => {
					return (hetElem.text.toLowerCase().indexOf('heatpump') !== -1)
				})
				this.waterHeaterOpts = _.filter(this.waterHeaterOpts, (hetElem) => {
					return (hetElem.text.toLowerCase().indexOf('heatpump') !== -1)
				})
			} else {
				if (this.heatSysStore.length > 0) {
					this.control.heatSys = this.heatSysStore
					this.control.coolSys = this.coolSysStore
					this.waterHeaterOpts = this.waterHeaterOptsStore
				}
			}
		},
		addSystem () {
			this.project.mechSystems.HVACSys.push({
				allElectric: false,		// All-Electric Home TODO: this should be inside each HVAC System?
				type: 'FURN.90',		// Heating System Type
				areaServ: 0,			// Area Served
				noSystems: 0,			// Number of systems
				supplyRegLoc: 'Attic_Floor', // Supply register location
				coolSysType: 'AC.10',	// Cooling system type
				lowLeakAirHand: true,	// Low Leakage Air Handler
				heatRecVentFan: false,	// Heat recovery ventilator fan desired
				multiSpeedComp: true,	// Multi-Speed compresor
				leesTwelveFeetDucts: true,	// Less than 12 feet of ducts in unconditioned space
				houseFanDes: true		// Whole house fan desired
			})
		},
		deleteSystem (index) {
			this.project.mechSystems.HVACSys.splice(index, 1)
		},
		addWaterHeater () {
			this.project.mechSystems.waterHeater.push({
				type: this.projConst.waterHeater.type.TANKLESS.value,	// Water Heater type
				quantity: 1,
				location: ''
			})
		},
		deleteWaterHeater (index) {
			this.project.mechSystems.waterHeater.splice(index, 1)
		},
		newWaterHeaterChange (index) {
			if (this.project.mechSystems.waterHeater[index].type === this.projConst.waterHeater.type.HEATPUMP.value) {
				this.project.mechSystems.waterHeater[index].location = this.projConst.waterHeater.heatpumpDefLoc
			}
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/app/take-off-tool/tabs-components/mechanical-systems.vue